export const NOTIFICATION_CATEGORIES = [
  { id: 'all', label: 'All', icon: 'Bell' },
  { id: 'capital-call', label: 'Capital Calls', icon: 'PoundSterling' },
  { id: 'milestone', label: 'Milestones', icon: 'Flag' },
  { id: 'esg', label: 'ESG Alerts', icon: 'Leaf' },
  { id: 'document', label: 'Documents', icon: 'FileText' },
  { id: 'deal-movement', label: 'Deal Movements', icon: 'ArrowRightLeft' },
  { id: 'archived', label: 'Archived', icon: 'Archive' },
];

export const CATEGORY_STYLES = {
  'capital-call': {
    bg: 'bg-amber-100',
    text: 'text-amber-700',
    border: 'border-amber-400',
    icon: 'PoundSterling',
    label: 'Capital Call',
  },
  milestone: {
    bg: 'bg-green-100',
    text: 'text-green-700',
    border: 'border-green-400',
    icon: 'Flag',
    label: 'Milestone',
  },
  esg: {
    bg: 'bg-teal-100',
    text: 'text-teal-700',
    border: 'border-teal-400',
    icon: 'Leaf',
    label: 'ESG Alert',
  },
  document: {
    bg: 'bg-blue-100',
    text: 'text-blue-700',
    border: 'border-blue-400',
    icon: 'FileText',
    label: 'Document',
  },
  'deal-movement': {
    bg: 'bg-indigo-100',
    text: 'text-indigo-700',
    border: 'border-indigo-400',
    icon: 'ArrowRightLeft',
    label: 'Deal Movement',
  },
  system: {
    bg: 'bg-slate-100',
    text: 'text-slate-600',
    border: 'border-slate-300',
    icon: 'Bell',
    label: 'System',
  },
};

export const PRIORITY_STYLES = {
  High: { bg: 'bg-red-100', text: 'text-red-700', dot: 'bg-red-500' },
  Medium: { bg: 'bg-amber-100', text: 'text-amber-700', dot: 'bg-amber-500' },
  Low: { bg: 'bg-slate-100', text: 'text-slate-600', dot: 'bg-slate-400' },
};

export const NOTIFICATIONS_SEED = [
  // ── Capital Calls ────────────────────────────────────────────────────────────
  {
    id: 'n1',
    category: 'capital-call',
    priority: 'High',
    roleTarget: ['investment_team', 'finance_team', 'platform_admin'],
    title: 'Capital Call: Solano Wind Farm SPV — £4.2m due',
    description: 'Your pro-rata capital call of £4.2m is due on 15 January 2026. Please arrange transfer to the SPV escrow account.',
    asset: 'Solano Wind Farm',
    assetPath: '/asset-detail-page',
    timestamp: new Date(Date.now() - 1 * 60 * 60 * 1000)?.toISOString(),
    isRead: false,
    isArchived: false,
    cta: { label: 'View Capital Call', path: '/deals/spv' },
  },
  {
    id: 'n2',
    category: 'capital-call',
    priority: 'Medium',
    roleTarget: ['investment_team', 'finance_team', 'platform_admin'],
    title: 'Upcoming Capital Call: Elbe Biomass Plant SPV — £7.8m in 30 days',
    description: 'A capital call of £7.8m is scheduled in 30 days for Elbe Biomass Plant SPV. Please ensure funds are available in your nominated account.',
    asset: 'Elbe Biomass Plant',
    assetPath: '/spv-dashboard',
    timestamp: new Date(Date.now() - 3 * 60 * 60 * 1000)?.toISOString(),
    isRead: false,
    isArchived: false,
    cta: { label: 'View SPV', path: '/deals/spv' },
  },
  {
    id: 'n3',
    category: 'capital-call',
    priority: 'Low',
    roleTarget: ['investment_team', 'finance_team', 'platform_admin'],
    title: 'Capital Call Confirmed: Avon Water Treatment SPV — £2.1m received',
    description: 'Your capital contribution of £2.1m for Avon Water Treatment SPV has been received and confirmed by the SPV administrator.',
    asset: 'Avon Water Treatment Works',
    assetPath: '/asset-detail-page',
    timestamp: new Date(Date.now() - 5 * 60 * 60 * 1000)?.toISOString(),
    isRead: true,
    isArchived: false,
    cta: { label: 'View SPV', path: '/deals/spv' },
  },
  {
    id: 'n4',
    category: 'capital-call',
    priority: 'High',
    roleTarget: ['investment_team', 'finance_team', 'platform_admin'],
    title: 'Overdue Capital Call: Lisbon Metro Extension SPV — £3.5m — 5 days overdue',
    description: 'The capital call of £3.5m for Lisbon Metro Extension SPV is now 5 days overdue. Immediate action is required to avoid default penalties.',
    asset: 'Lisbon Metro Extension',
    assetPath: '/pipeline',
    timestamp: new Date(Date.now() - 8 * 60 * 60 * 1000)?.toISOString(),
    isRead: false,
    isArchived: false,
    cta: { label: 'Contact SPV Manager', path: '/deals/spv' },
  },
  // ── Milestones ───────────────────────────────────────────────────────────────
  {
    id: 'n5',
    category: 'milestone',
    priority: 'High',
    roleTarget: ['investment_team', 'asset_mgmt_team', 'finance_team', 'platform_admin'],
    title: 'Planning Consent Approved: Nordic Fibre Network Phase II — Stage gate unlocked',
    description: 'Full planning consent has been granted for Nordic Fibre Network Phase II. This unlocks the next stage gate and enables progression to financial close.',
    asset: 'Nordic Fibre Network',
    assetPath: '/asset-detail-page',
    timestamp: new Date(Date.now() - 24 * 60 * 60 * 1000)?.toISOString(),
    isRead: false,
    isArchived: false,
    cta: { label: 'View Milestone', path: '/portfolio/assets' },
  },
  {
    id: 'n6',
    category: 'milestone',
    priority: 'Medium',
    roleTarget: ['asset_mgmt_team', 'investment_team', 'platform_admin'],
    title: 'Construction Start Scheduled: Elbe Biomass Plant — 1 Feb 2026',
    description: 'Construction commencement has been confirmed for 1 February 2026. Site mobilisation activities are underway.',
    asset: 'Elbe Biomass Plant',
    assetPath: '/asset-detail-page',
    timestamp: new Date(Date.now() - 26 * 60 * 60 * 1000)?.toISOString(),
    isRead: true,
    isArchived: false,
    cta: { label: 'View Timeline', path: '/portfolio/assets' },
  },
  {
    id: 'n7',
    category: 'milestone',
    priority: 'Low',
    roleTarget: ['asset_mgmt_team', 'investment_team', 'finance_team', 'platform_admin'],
    title: 'Commercial Operation Date Achieved: Solano Wind Farm — COD confirmed 12 Dec 2025',
    description: 'Solano Wind Farm has achieved its Commercial Operation Date on 12 December 2025. The asset is now fully operational.',
    asset: 'Solano Wind Farm',
    assetPath: '/asset-detail-page',
    timestamp: new Date(Date.now() - 48 * 60 * 60 * 1000)?.toISOString(),
    isRead: true,
    isArchived: false,
    cta: { label: 'View Asset', path: '/portfolio/assets' },
  },
  {
    id: 'n8',
    category: 'milestone',
    priority: 'Medium',
    roleTarget: ['investment_team', 'finance_team', 'platform_admin'],
    title: 'Milestone Delayed: Lisbon Metro Extension — Financial Close pushed to Q2 2026',
    description: 'Financial Close for Lisbon Metro Extension has been delayed to Q2 2026 due to extended lender negotiations. Updated timeline available in the pipeline.',
    asset: 'Lisbon Metro Extension',
    assetPath: '/pipeline',
    timestamp: new Date(Date.now() - 72 * 60 * 60 * 1000)?.toISOString(),
    isRead: false,
    isArchived: false,
    cta: { label: 'View Pipeline', path: '/deals/pipeline' },
  },
  // ── ESG Alerts ───────────────────────────────────────────────────────────────
  {
    id: 'n9',
    category: 'esg',
    priority: 'High',
    roleTarget: ['asset_mgmt_team', 'investment_team', 'platform_admin'],
    title: 'ESG Alert: Biodiversity net gain below threshold — Tyne Bridge Toll Road',
    description: 'Current biodiversity net gain score is 0.8x against the 1.15x target. A remediation plan is required within 30 days to maintain compliance.',
    asset: 'Tyne Bridge Toll Road',
    assetPath: '/esg-reporting',
    timestamp: new Date(Date.now() - 2 * 60 * 60 * 1000)?.toISOString(),
    isRead: false,
    isArchived: false,
    cta: { label: 'View ESG Report', path: '/operations/esg' },
  },
  {
    id: 'n10',
    category: 'esg',
    priority: 'Medium',
    roleTarget: ['asset_mgmt_team', 'investment_team', 'platform_admin'],
    title: 'LTIFR Spike Detected: Elbe Biomass Plant Q3 2025 — 0.82 vs 0.34 benchmark',
    description: 'Lost Time Injury Frequency Rate has spiked to 0.82 against the 0.34 benchmark for Q3 2025. Incident review and corrective action plan required.',
    asset: 'Elbe Biomass Plant',
    assetPath: '/esg-reporting',
    timestamp: new Date(Date.now() - 4 * 60 * 60 * 1000)?.toISOString(),
    isRead: false,
    isArchived: false,
    cta: { label: 'View KPIs', path: '/operations/esg' },
  },
  {
    id: 'n11',
    category: 'esg',
    priority: 'Low',
    roleTarget: ['investment_team', 'ic_member', 'asset_mgmt_team', 'finance_team', 'legal_comp_team', 'platform_admin'],
    title: 'ESG Report Published: Portfolio Q3 2025 Sustainability Report now available',
    description: 'The Q3 2025 Portfolio Sustainability Report has been published and is available for download in the Data Room.',
    asset: 'Portfolio',
    assetPath: '/esg-reporting',
    timestamp: new Date(Date.now() - 30 * 60 * 60 * 1000)?.toISOString(),
    isRead: true,
    isArchived: false,
    cta: { label: 'Download Report', path: '/operations/data-room' },
  },
  {
    id: 'n12',
    category: 'esg',
    priority: 'Medium',
    roleTarget: ['asset_mgmt_team', 'investment_team', 'finance_team', 'platform_admin'],
    title: 'Board Diversity Target Missed: Porto Digital Hub — 33% vs 40% target',
    description: 'Board gender diversity stands at 33% against the 40% target for Porto Digital Hub. Governance improvement plan required.',
    asset: 'Porto Digital Hub',
    assetPath: '/esg-reporting',
    timestamp: new Date(Date.now() - 50 * 60 * 60 * 1000)?.toISOString(),
    isRead: false,
    isArchived: false,
    cta: { label: 'View Governance', path: '/operations/esg' },
  },
  // ── Documents ────────────────────────────────────────────────────────────────
  {
    id: 'n13',
    category: 'document',
    priority: 'Medium',
    roleTarget: ['investment_team', 'ic_member', 'legal_comp_team', 'platform_admin'],
    title: 'New Document Uploaded: Avon Water Treatment Works — Technical Due Diligence Report v2.1',
    description: 'Uploaded by J. Harrison on 18 Dec 2025. Review requested by IC committee. Please review and provide comments by 22 December 2025.',
    asset: 'Avon Water Treatment Works',
    assetPath: '/data-room',
    timestamp: new Date(Date.now() - 6 * 60 * 60 * 1000)?.toISOString(),
    isRead: false,
    isArchived: false,
    cta: { label: 'Open Document', path: '/operations/data-room' },
  },
  {
    id: 'n14',
    category: 'document',
    priority: 'Low',
    roleTarget: ['legal_comp_team', 'investment_team', 'platform_admin'],
    title: 'Document Expiring: KYC Pack — GlobalInfra Partners — expires in 14 days',
    description: 'The KYC Pack for GlobalInfra Partners is due to expire in 14 days. Please arrange renewal to maintain compliance.',
    asset: 'GlobalInfra Partners',
    assetPath: '/data-room',
    timestamp: new Date(Date.now() - 28 * 60 * 60 * 1000)?.toISOString(),
    isRead: true,
    isArchived: false,
    cta: { label: 'View Data Room', path: '/operations/data-room' },
  },
  {
    id: 'n15',
    category: 'document',
    priority: 'High',
    roleTarget: ['external_investor', 'platform_admin'],
    contextIds: ['ctx-external-investor', 'ctx-platform-admin'],
    title: 'NDA Signature Required: Nordic Fibre Network Phase II — Action required before 22 Dec 2025',
    description: 'Your signature is required on the NDA for Nordic Fibre Network Phase II before 22 December 2025. Access to deal documents is restricted until signed.',
    asset: 'Nordic Fibre Network',
    assetPath: '/data-room',
    timestamp: new Date(Date.now() - 7 * 60 * 60 * 1000)?.toISOString(),
    isRead: false,
    isArchived: false,
    cta: { label: 'Sign Document', path: '/operations/data-room' },
  },
  {
    id: 'n16',
    category: 'document',
    priority: 'Low',
    roleTarget: ['investment_team', 'finance_team', 'platform_admin'],
    title: 'Version Updated: Financial Model — Solano Wind Farm — v4.2 now available',
    description: 'The Financial Model for Solano Wind Farm has been updated to v4.2. Key changes include revised capex assumptions and updated debt terms.',
    asset: 'Solano Wind Farm',
    assetPath: '/data-room',
    timestamp: new Date(Date.now() - 52 * 60 * 60 * 1000)?.toISOString(),
    isRead: true,
    isArchived: false,
    cta: { label: 'View History', path: '/operations/data-room' },
  },
  // ── Deal Movements ───────────────────────────────────────────────────────────
  {
    id: 'n17',
    category: 'deal-movement',
    priority: 'High',
    roleTarget: ['investment_team', 'ic_member', 'platform_admin'],
    title: 'Deal Advanced: Nordic Fibre Network Phase II moved to IC Review',
    description: 'Deal has progressed from Diligence to IC Review stage. IC meeting scheduled for 8 January 2026. Please review the IC memo in the Data Room.',
    asset: 'Nordic Fibre Network',
    assetPath: '/pipeline',
    timestamp: new Date(Date.now() - 9 * 60 * 60 * 1000)?.toISOString(),
    isRead: false,
    isArchived: false,
    cta: { label: 'View Deal', path: '/deals/pipeline' },
  },
  {
    id: 'n18',
    category: 'deal-movement',
    priority: 'Medium',
    roleTarget: ['investment_team', 'platform_admin'],
    title: 'New Deal Added to Pipeline: East Anglia Carbon Capture — Sourcing stage',
    description: 'A new opportunity, East Anglia Carbon Capture, has been added to the pipeline at Sourcing stage. Initial screening materials are available.',
    asset: 'East Anglia Carbon Capture',
    assetPath: '/pipeline',
    timestamp: new Date(Date.now() - 32 * 60 * 60 * 1000)?.toISOString(),
    isRead: false,
    isArchived: false,
    cta: { label: 'View Opportunity', path: '/marketplace/opportunities' },
  },
  {
    id: 'n19',
    category: 'deal-movement',
    priority: 'Low',
    roleTarget: ['investment_team', 'finance_team', 'asset_mgmt_team', 'platform_admin'],
    title: 'Deal Status Updated: Lisbon Metro Extension — Risk rating revised to Medium',
    description: 'The risk rating for Lisbon Metro Extension has been revised from High to Medium following updated financial projections and lender feedback.',
    asset: 'Lisbon Metro Extension',
    assetPath: '/pipeline',
    timestamp: new Date(Date.now() - 54 * 60 * 60 * 1000)?.toISOString(),
    isRead: true,
    isArchived: false,
    cta: { label: 'View Pipeline', path: '/deals/pipeline' },
  },
  {
    id: 'n20',
    category: 'deal-movement',
    priority: 'Medium',
    roleTarget: ['investment_team', 'finance_team', 'legal_comp_team', 'platform_admin'],
    title: 'SPV Created: Elbe Biomass Plant SPV — Syndication round now open',
    description: 'The SPV for Elbe Biomass Plant has been formally created. The syndication round is now open for eligible investors.',
    asset: 'Elbe Biomass Plant',
    assetPath: '/spv-dashboard',
    timestamp: new Date(Date.now() - 76 * 60 * 60 * 1000)?.toISOString(),
    isRead: true,
    isArchived: false,
    cta: { label: 'View SPV', path: '/deals/spv' },
  },
  // ── System ───────────────────────────────────────────────────────────────────
  {
    id: 'n21',
    category: 'system',
    priority: 'Low',
    roleTarget: ['platform_admin'],
    title: 'Login from new device detected — London, UK — 15 Dec 2025',
    description: 'A login was detected from a new device in London, UK on 15 December 2025. If this was not you, please contact support immediately.',
    asset: null,
    assetPath: null,
    timestamp: new Date(Date.now() - 5 * 24 * 60 * 60 * 1000)?.toISOString(),
    isRead: true,
    isArchived: true,
    cta: null,
  },
  {
    id: 'n22',
    category: 'system',
    priority: 'Low',
    roleTarget: ['finance_team', 'asset_mgmt_team', 'platform_admin'],
    title: 'Quarterly report generation completed — Q3 2025 ESG Report ready',
    description: 'The Q3 2025 ESG Report has been successfully generated and is available for download in the Data Room.',
    asset: 'Portfolio',
    assetPath: '/data-room',
    timestamp: new Date(Date.now() - 6 * 24 * 60 * 60 * 1000)?.toISOString(),
    isRead: true,
    isArchived: true,
    cta: { label: 'View Report', path: '/operations/data-room' },
  },
];
